import React from 'react';

import BenchLink, {BenchLinkProps} from 'link-preview/BenchLink';

interface ProcedurePageLinkProps extends BenchLinkProps {}

export default function ProcedurePageLink(props: ProcedurePageLinkProps): JSX.Element {
  return <BenchLink stopPropagation={true} {...props} />;
}
